import ApiFunctions from './ApiFunctions';

export class Login {
  static async login(login, urlParams) { return ApiFunctions.login('authenticate', login, urlParams); }
}

export class Companies {
  static async get(urlParams) { return ApiFunctions.getAll('companies', urlParams); }
  static async getOne(id, urlParams) { return ApiFunctions.getOne('companies', id, urlParams); }
  static async getPaged(limit, page, urlParams) { return ApiFunctions.getPaged('companies', limit, page, urlParams); }
  static async create(company, urlParams) { return ApiFunctions.create('companies', company, urlParams); }
}

export class Contacts {
  static async get(urlParams) { return ApiFunctions.get('contacts', urlParams); }
  static async getOne(id, urlParams) { return ApiFunctions.getOne('contacts', id, urlParams); }
  static async getPaged(limit, page, urlParams) { return ApiFunctions.getPaged('contacts', limit, page, urlParams); }
}

export class Tasks {
  static async get(urlParams) { return ApiFunctions.getByUser('tasks', urlParams); }
  static async getAll(urlParams) { return ApiFunctions.getAll('tasks', urlParams); }
}

export class Deals {
  static async get(urlParams) { return ApiFunctions.getByUser('deals', urlParams); }
  static async getAll(urlParams) { return ApiFunctions.getAll('deals', urlParams); }
  static async getDealStages(urlParams) { return ApiFunctions.getAll('dealStages', urlParams); }
}

export class Appointments {
  static async get(urlParams) { return ApiFunctions.getByUser('appointments', urlParams); }
  static async getAll(urlParams) { return ApiFunctions.getAll('appointments', urlParams); }
}

export class Tickets {
  static async get(urlParams) { return ApiFunctions.getByUser('tickets', urlParams); }
  static async getAll(urlParams) { return ApiFunctions.getAll('tickets', urlParams); }
  static async getOne(id, urlParams) { return ApiFunctions.getOne('tickets', id, urlParams); }
  static async getPaged(limit, page, urlParams) { return ApiFunctions.getPagedByUser('tickets', limit, page, urlParams); }
  static async getAllPaged(limit, page, urlParams) { return ApiFunctions.getPaged('tickets', limit, page, urlParams); }
}

export class Schedule {
  static async get(urlParams) { return ApiFunctions.getAll('calendar', urlParams); }
}

export class Zipcode {
  static async get(urlParams) { return ApiFunctions.getAll('postcode', urlParams); }
}

export class KvK {
  static async get(urlParams) { return ApiFunctions.getAll('kvk', urlParams); }
}



// WEBPACK FOOTER //
// ./src/services/api/ApiRoutes.js